export default __webpack_public_path__ + "static/media/datamatrix.02c3367a.svg";